import React, { useContext, useEffect, useState } from "react";
import "../css/graph_section.css";
import { convertTimestampToCzech, strTsToStrDate, getDatesBetween, tsToDateObjectOnlyDay, dateObjToStrDate } from "../helpers/date_conversion";
import { DateRange } from 'react-date-range';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import { Bar, BarChart, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, } from "recharts";
import { cs } from 'date-fns/locale';
import { getStuff } from "../helpers/auth"
import { AlertsContext } from "./Layout";
import { authenticatedContext } from "../App";

export const GraphSection = ({ aidRecords: initAidRecords, reqUrl, refresh = null}) => {
  const { authenticated, setAuthenticated } = useContext(authenticatedContext);
  const [aidRecords, setAidRecords] = useState(initAidRecords);
  const [formatedData, setFormatedData] = useState(null);
  const [pickerOpen, setPickerOpen] = useState(false);
  const [rangePicker, setRangePicker] = useState([
    {
      startDate: tsToDateObjectOnlyDay(initAidRecords.for_period[0]),
      endDate: tsToDateObjectOnlyDay(initAidRecords.for_period[1]),
      key: 'selection'
    }
  ]);

  const addAlertBanner = useContext(AlertsContext);

  useEffect(()=>{
    setFormatedData(formatGraphData(aidRecords.for_period, aidRecords.aid_records));
  }, [aidRecords]);


  useEffect(()=>{
    if ((!pickerOpen)
      && (rangePicker[0].startDate !== null)
      && (rangePicker[0].endDate !== null)
      && (tsToDateObjectOnlyDay(aidRecords.for_period[0]) != tsToDateObjectOnlyDay(rangePicker[0].startDate))
      && (tsToDateObjectOnlyDay(aidRecords.for_period[1]) != tsToDateObjectOnlyDay(rangePicker[0].endDate))
      ) {
        const start_d = dateObjToStrDate(rangePicker[0].startDate)
        const end_d = dateObjToStrDate(rangePicker[0].endDate)

        getStuff( reqUrl + `${start_d}/${end_d}/`).then((res) => {
          if(res.status === 200){
            setAidRecords(res.data)
          }else if (res.status === 401){
            addAlertBanner("Znovu se přihlašte", "info");
            setAuthenticated(false);
          }else{
            addAlertBanner("Chyba!", "warning");
          }
        });
    } 

  }, [pickerOpen, reqUrl, refresh]);
  
  return (
    <section className="graph-section">
      <div className="toolbar">
        <div className="graph-period-title-container">
          <div className="graph-title">Poskytnutá pomoc za období</div>
          <div className="graph-controls-container" >
            <div className="graph-period" onClick={()=>(setPickerOpen(!pickerOpen))}>
              <div className="date-text">
                {convertTimestampToCzech(aidRecords.for_period[0])}{" - "}
                {convertTimestampToCzech(aidRecords.for_period[1])}
              </div>
              <img
                src="/img/svg/down_arrow_in_black_circle.svg"
                alt="down arrow"
                className="down-arrow"
                style={pickerOpen ? { transform: "rotate(180deg)" } : {}}
              />
            </div>
            <div className="just-placeholder">

              {pickerOpen &&
                <DateRange className="date-range-picker"
                  showSelectionPreview={true}
                  moveRangeOnFirstSelection={false}
                  months={2}
                  locale={cs}
                  onChange={item => setRangePicker([item.selection])}
                  ranges={rangePicker}
                  direction="horizontal" 
                  disabledDay={(day)=>(
                    day > new Date()
                  )}/>
              }
            </div>
          </div>
        </div>
      </div>
      <section className={pickerOpen ? "graph-container blur-5" : "graph-container"}>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart
            width={500}
            height={300}
            data={formatedData}
            margin={{
              top: 5,
              right: 30,
              left: 20,
              bottom: 5,
            }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis
              dataKey="time"
              domain={["auto", "auto"]}
              name="Time"
            />
            <YAxis dataKey="value" name="value" />
            <Tooltip />
            <Legend />
            <Bar
              strokeWidth={5}
              type="monotone"
              dataKey="value"
              stroke="#8884d8"
              name="vydaná pomoc"
              fill="#8884d8"
            />
          </BarChart>
        </ResponsiveContainer>
      </section>
    </section>
  );
};



function formatGraphData(period, aid_data) {
  var data = getDatesBetween(period[0], period[1]);

  aid_data.forEach((value) => {
    var ts = strTsToStrDate(value.ts);
    data[ts] += 1;
  });

  var formated_data = [];
  for (const [key, val] of Object.entries(data)) {
    formated_data.push({ time: key, value: val });
  }
  return formated_data;
}



